define(['jquery'], function ($) {
	"use strict";

	let PLUGIN_NAME = "searchPlaces";

	let DEBUG = false;

	let DEFAULTS = {
		selectors:  {
			input: '#placesQuery',
			list: '.sales-places-grid',
			item: '.grid-item[id]',
			areas: '.item-title, .item-content-address'
		}
	};

	/**
	 *
	 * @param element
	 * @param options
	 * @constructor
	 */
	let SearchPlaces = function (element, options) {
		let self = this;
		self.element = element;
		self.$t = $(self.element);

		self._name = PLUGIN_NAME;
		self._defaults = DEFAULTS;

		self.options = $.extend(true, {}, DEFAULTS, options);
		self.objects = {};
		self.data = {};

		// if ( !$( self.options.targetElementSelector ).length ) {
		// 	$.error("Argument error.");
		// }

		self.initialise();
	};

	/**
	 * Init function
	 * @private
	 */
	SearchPlaces.prototype.initialise = function () {
		let self = this;

		self.mapObjects();
		self.bindEvents();
	};

	SearchPlaces.prototype.mapObjects = function () {
		let self = this;

		clog( 'map objects' );

		self.objects.$form = self.$t;
		self.objects.$searchInput = $( self.options.selectors.input );
		self.objects.$searchList = $( self.options.selectors.list );
		self.objects.$searchItems = $( self.objects.$searchList.find( self.options.selectors.item ) );
	};

	SearchPlaces.prototype.bindEvents = function () {
		let self = this;

		clog( 'bind events' );

		self.$t.on("submit." + self._name, function (evn) {
			clog(evn);
			evn.preventDefault();
			evn.stopPropagation();
			self.data.searchTerm = self._escapeRegExp(self.objects.$searchInput.val());
			if ( !!self.data.searchTerm ) {
				self.filterItems(self.data.searchTerm);
			} else {
				self._showAllItems();
			}
		});

	};

	SearchPlaces.prototype.filterItems = function () {
		let self = this;

		self._showAllItems();
		self.objects.$searchItems.each(function(index, item) {
			// let item = self.objects.$searchItems.get(index);
			let re = new RegExp(self.data.searchTerm, 'gi');
			clog(re);
			if ( $(self.options.selectors.areas, item).text().match(re) ) {
				$(item).show();
			} else {
				$(item).hide();
			}
		});

	};

	SearchPlaces.prototype._showAllItems = function () {
		let self = this;
		self.objects.$searchItems.show();
	};

	/**
	 * Sanitize user input
	 * @see https://codereview.stackexchange.com/a/153702
	 */
	SearchPlaces.prototype._escapeRegExp = function (string){
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
	};

	let API = {};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 *        if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 *        if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		let args = arguments;

		return this.each(function () {
			let $this = $(this);

			// get plugin instance
			let plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new SearchPlaces(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};

	// simple logger
	function clog(){
		if ( DEBUG && window.console ) {
			console.group('Debug of ' + PLUGIN_NAME);
			for ( let arg in arguments ) {
				console.log( arguments[arg] );
			}
			console.groupEnd();
		}
	}

});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.searchPlaces.js